var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gradeDetail"},[_c('GradeDetail',{attrs:{"data":_vm.data}}),_c('div',{staticClass:"ftBtnBox"},[_c('Button',{attrs:{"type":'btnGray',"name":"返回"},on:{"handleClick":function($event){return _vm.$router.go(-1)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }